import html2canvas from 'html2canvas';

import ReportUtils from './reports';

class StaticRender {
    initStaticRenderer(container)
    {
        let static_cell = $('#static-widget', container);
        if (static_cell.length) {
            let cell = static_cell.find('[data-widget-id]');
            let subject = $('[name=subject]').val();
            let mode = static_cell.attr('data-render-mode');

            /*
                Cfr. WidgetDriver::statizable for details about rendering modes
            */

            if (mode == 'echarts') {
                static_cell.on('echarts.finished', (e, chart) => {
                    $.ajax({
                        method: 'POST',
                        data: {
                            widget: cell.attr('data-widget-id'),
                            subject: subject,
                            image: chart.getDataURL(),
                            _token: $('meta[name=csrf-token]').attr('content'),
                        },
                        success: function() {
                            let done = $('<div id="done">Saved</div>');
                            $('body').append(done);
                        }
                    });
                });
            }
            else {
                static_cell.on('widget_loaded', (e) => {
                    let div = document.getElementById("static-widget");

                    html2canvas(div).then((canvas) => {
                        $.ajax({
                            method: 'POST',
                            data: {
                                widget: cell.attr('data-widget-id'),
                                subject: subject,
                                image: canvas.toDataURL(),
                                _token: $('meta[name=csrf-token]').attr('content'),
                            },
                            success: function() {
                                /*
                                    This is appended to "notify" the Selenium
                                    instance that the chart has been processed
                                    and the process can be closed
                                */
                                let done = $('<div id="done">Saved</div>');
                                $('body').append(done);
                            }
                        });
                    });
                });
            }

            let reports = new ReportUtils();
            reports.loadCell(cell, 'render', subject);
        }
    }
}

export default StaticRender;
